export const LOADING_BAR_SHOW = 'LOADING_BAR_SHOW';
export const LOADING_BAR_HIDE = 'LOADING_BAR_HIDE';

export const showLoading = () => ({ type: LOADING_BAR_SHOW }) as const;
export const hideLoading = () => ({ type: LOADING_BAR_HIDE }) as const;
